import { useQuery } from "@tanstack/react-query";
import { fetchBillingStatus } from "../api/billing";
import { useAuth } from "./useAuth";

/**
 * Whether the signed-in user has Atlas Pro. Shares PlanPage's ["billing"]
 * cache; falls back to the session user's plan while billing is loading.
 * Display-only — every Pro feature is enforced server-side (requirePro / 402).
 */
export function useIsPro(): { isPro: boolean; isLoading: boolean } {
  const { user, isLoading: authLoading } = useAuth();
  const billingQuery = useQuery({
    queryKey: ["billing"],
    queryFn: fetchBillingStatus,
    staleTime: 60 * 1000,
    enabled: user != null,
  });

  return {
    isPro: billingQuery.data?.isPro ?? user?.plan === "pro",
    isLoading: authLoading || (user != null && billingQuery.isLoading),
  };
}
